import React from 'react'
import { ApplicationImportance } from '../application-importance'
import { MetadataValue } from '../applications-grid/shared'
import {
  Importance,
  Language,
  Metadata,
  Url,
  SizedTooltipList
} from './tooltip-content-pieces'

export function ServerApplicationTooltipContent({
  language,
  importance,
  url,
  metadata
}: {
  readonly language: string
  readonly importance: ApplicationImportance
  readonly url: string
  readonly metadata?: MetadataValue[]
}) {
  return (
    <SizedTooltipList>
      <li>
        <Url url={url} />
      </li>
      <li>
        <Importance importance={importance} />
      </li>
      <li>
        <Language language={language} />
      </li>
      {metadata && <Metadata values={metadata} />}
    </SizedTooltipList>
  )
}
